import { style, media } from 'typestyle'
import { important } from 'csx'
export const mb20mdi = style(media({ maxWidth: 768 }, { marginBottom: important('20px') }))
